import React, { useEffect, useState } from "react";

import CourseCard from "./CourseCard";
import { Link } from "react-router-dom";
import { getFeaturedPublishedCourses } from "../../controllers/coursesController";

const FeaturedCourses = () => {
  const [featuredCourses, setFeaturedCourses] = useState([]);

  const getFeaturedCoursesData = async () => {
    const FCourses = await getFeaturedPublishedCourses();
    
    if (FCourses.length > 0) {
      setFeaturedCourses(FCourses);
    }
  };
  useEffect(() => {
    getFeaturedCoursesData();
  }, []);

  return (
    <section className="courses" id="courses">
      <div className="course__top">
        <div className="course__top__left w-60">
          <h2>Featured Courses</h2>
        </div>
      </div>
      <div className="courses__list">
        {featuredCourses.length > 0 ? (
          featuredCourses.map((item) => {
            if (item.isFeatured) {
              return <CourseCard key={item.id} item={item} />;
            } else {
              return null;
            }
          })
        ) : (
          <h3>No Featured Courses Found !!!</h3>
        )}
      </div>
      <div className="courses__bottom">
        <Link to="/courses">See All</Link>
      </div>
    </section>
  );
};

export default FeaturedCourses;
